import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

// filter api repo
export const getFeedbackFilterRepo = (params) => {
    return axios({
        baseURL:
            ServiceUrls.CP_FEEDBACK_SERVICE +
            axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        method: "GET",
        url: Urls.GET_FEEDBACK_FILTER_API,
        params: params,
    });
};

// list api repo
export const getFeedbackListRepo = (params) => {
    return axios({
        baseURL:
            ServiceUrls.CP_FEEDBACK_SERVICE +
            axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        method: "GET",
        url: Urls.GET_FEEDBACK_LISTING_API,
        params: params,
    });
};

export const postFeedbackListRepo = (data) => {
    return axios({
        baseURL:
            ServiceUrls.CP_FEEDBACK_SERVICE +
            axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        method: "POST",
        url: Urls.GET_FEEDBACK_LISTING_API,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    });
};

// detail api repo
export const getFeedbackDetailRepo = (id,params) => {
    return axios({
        baseURL:
            ServiceUrls.CP_FEEDBACK_SERVICE +
            axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        method: "GET",
        url: Urls.GET_FEEDBACK_DETAIL_API + `/${id}`,
        params: params,
    });
};

export const putFeedbackDetailRepo = (id,data) => {
    return axios({
        baseURL:
            ServiceUrls.CP_FEEDBACK_SERVICE +
            axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        method: 'PUT',
        url: Urls.GET_FEEDBACK_DETAIL_API + `/${id}`,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export const putFeedbackMappedStatusRepo = (data) => {
    return axios({
        baseURL:
            ServiceUrls.CP_FEEDBACK_SERVICE +
            axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
        method: 'PUT',
        url: Urls.PUT_FEEDBACK_MAPPED_STATUS_API,
        data: data,
    })
}
